var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
import styled, { css } from 'styled-components';
import { Button as BaseButton } from '@finect/tabular-core/Button';
import { getFont } from '@finect/tabular-utils/getFont';
import { minMediaQueries, maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { fontSmoothing } from '@finect/tabular-utils/fontSmoothing';
export var Button = styled(BaseButton).withConfig({
  displayName: "partials__Button",
  componentId: "sc-1pwvfn9-0"
})(["padding:12px 30px;", ";margin-top:5px;", " ", " ", " svg{margin-left:7px;vertical-align:middle;}", ""], getFont(1), function (_ref) {
  var position = _ref.position;
  return position === 'left' && 'margin-right: auto;';
}, function (_ref2) {
  var position = _ref2.position;
  return position === 'center' && css(["margin-left:auto;margin-right:auto;"]);
}, function (_ref3) {
  var position = _ref3.position;
  return position === 'right' && 'margin-left: auto;';
}, function (_ref4) {
  var yellow = _ref4.yellow,
    theme = _ref4.theme;
  return yellow && "\n      background-color: ".concat(theme.colors.warn, "; \n      color: #000;\n      border-radius: 30px;\n      padding: 4px 20px !important;\n\n      &:hover {\n        background-color: ").concat(theme.colors.warnL, " !important;\n      }\n    ");
});
export var Inner = styled.div.withConfig({
  displayName: "partials__Inner",
  componentId: "sc-1pwvfn9-1"
})(["display:flex;flex-direction:column;justify-content:space-between;", " ", " font-size:16px;line-height:18px;color:rgb(0 0 0 / 0.7);text-align:center;", ";", " background-position:", " center;background-size:cover;", " ", " ", ";"], function (_ref5) {
  var _ref5$bordered = _ref5.bordered,
    bordered = _ref5$bordered === void 0 ? true : _ref5$bordered;
  return bordered ? "border-radius: 12px;" : '';
}, function (_ref6) {
  var backgroundColor = _ref6.backgroundColor;
  return backgroundColor ? "background-color: ".concat(backgroundColor, ";") : '';
}, maxMediaQueries.phone(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", "\n    "])), function (_ref7) {
  var coverImage = _ref7.coverImage,
    coverImagePhone = _ref7.coverImagePhone;
  return coverImagePhone ? "background-image: url(".concat(coverImagePhone, ");") : coverImage ? "background-image: url(".concat(coverImage, ")") : '';
}), function (_ref8) {
  var coverImage = _ref8.coverImage;
  return coverImage ? "background-image: url(".concat(coverImage, ");") : '';
}, function (props) {
  return props.coverImagePosition || 'center';
}, function (_ref9) {
  var variant = _ref9.variant;
  return variant === 'small' || variant === 'xsmall' && css(["flex-direction:column;", ""], minMediaQueries.tablet(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        flex-direction: row;\n      "]))));
}, function (_ref10) {
  var variant = _ref10.variant;
  return variant === 'small' || variant === 'xsmall' && css(["", " ", ";"], minMediaQueries.miniDesktop(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n        min-height: 160px;\n        max-height: 160px;\n      "]))), maxMediaQueries.phone(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n        ", " {\n          padding: 9px 24px;\n          ", ";\n        }\n      "])), Button, getFont(0)));
}, function (_ref11) {
  var variant = _ref11.variant;
  return variant === 'large' && css(["", ""], minMediaQueries.tablet(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n        min-height: ", ";\n      "])), function (_ref12) {
    var height = _ref12.height;
    return height || '320px';
  }));
});
export var HeaderContent = styled.div.withConfig({
  displayName: "partials__HeaderContent",
  componentId: "sc-1pwvfn9-2"
})(["display:flex;flex-direction:column;width:100%;padding:36px;color:", ";text-align:left;img{flex-grow:0;flex-shrink:0;max-width:120px;", ";}", ";", " ", " ", " ", ";", ";"], function (props) {
  return props.color;
}, minMediaQueries.tablet(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n      max-width: 180px;\n    "]))), maxMediaQueries.phablet(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    padding: 18px;\n  "]))), function (props) {
  return props.position === 'left' && css(["width:62%;margin-right:auto;text-align:left;"]);
}, function (props) {
  return props.position === 'center' && css(["margin-left:auto;margin-right:auto;"]);
}, function (props) {
  return props.position === 'right' && css(["width:62%;margin-left:auto;text-align:right;"]);
}, maxMediaQueries.miniDesktop(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n    width: 80%;\n  "]))), function (_ref13) {
  var variant = _ref13.variant;
  return variant === 'small' || variant === 'xsmall' && css(["flex-direction:column;width:80%;", ";", ";", ";", ";"], minMediaQueries.miniDesktop(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n        align-items: center;\n        flex-direction: row;\n        width: 70%;\n      "]))), minMediaQueries.desktop(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n        width: 75%;\n      "]))), maxMediaQueries.miniDesktop(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n        width: 70%;\n      "]))), maxMediaQueries.phablet(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n        width: 100%;\n      "]))));
});
export var Title = styled.h3.withConfig({
  displayName: "partials__Title",
  componentId: "sc-1pwvfn9-3"
})(["display:block;margin:", ";margin-bottom:16px;font-weight:", ";", ";", " ", ";", ";", ";", ";", ";"], function (_ref14) {
  var noMargin = _ref14.noMargin;
  return noMargin ? '0' : '16px 0';
}, function (_ref15) {
  var _ref15$titleFontWeigh = _ref15.titleFontWeight,
    titleFontWeight = _ref15$titleFontWeigh === void 0 ? 600 : _ref15$titleFontWeigh;
  return titleFontWeight;
}, fontSmoothing, function (_ref16) {
  var titleWidth = _ref16.titleWidth;
  return titleWidth && "width: ".concat(titleWidth, "%;");
}, getFont(3, 'compact'), minMediaQueries.phablet(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["", ";"])), getFont(6, 'compact')), function (_ref17) {
  var variant = _ref17.variant,
    _ref17$titleWidth = _ref17.titleWidth,
    titleWidth = _ref17$titleWidth === void 0 ? 55 : _ref17$titleWidth;
  return variant === 'xsmall' && css(["", " ", ""], minMediaQueries.phablet(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["", ";"])), getFont(3, 'compact')), minMediaQueries.miniDesktop(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n      width: ", "%;\n      margin: ", ";\n      "])), titleWidth + 5, function (_ref18) {
    var noMargin = _ref18.noMargin;
    return noMargin ? '0' : '0 auto';
  }));
}, function (_ref19) {
  var variant = _ref19.variant,
    _ref19$titleWidth = _ref19.titleWidth,
    titleWidth = _ref19$titleWidth === void 0 ? 55 : _ref19$titleWidth;
  return variant === 'small' && css(["", " ", ""], minMediaQueries.phablet(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["", ";"])), getFont(4, 'compact')), minMediaQueries.miniDesktop(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n      width: ", "%;\n        margin: ", ";\n      "])), titleWidth + 5, function (_ref20) {
    var noMargin = _ref20.noMargin;
    return noMargin ? '0' : '0 auto';
  }));
}, maxMediaQueries.phablet(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n    max-width: 100%;\n  "]))));
export var Subtitle = styled.h4.withConfig({
  displayName: "partials__Subtitle",
  componentId: "sc-1pwvfn9-4"
})(["display:block;", ";", ";&:not(:last-child){", ";}"], getFont(0, 'compact'), minMediaQueries.phablet(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n    ", ";\n  "])), getFont(2, 'compact')), function (_ref21) {
  var noPadding = _ref21.noPadding;
  return !noPadding && 'padding-bottom: 18px;';
});
export var BottomContent = styled.div.withConfig({
  displayName: "partials__BottomContent",
  componentId: "sc-1pwvfn9-5"
})(["display:flex;flex-direction:column;justify-content:center;padding:36px;padding-top:0;text-align:right;", ";", ";"], maxMediaQueries.phablet(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["\n    padding: 18px;\n    padding-top: 0;\n  "]))), function (_ref22) {
  var variant = _ref22.variant;
  return variant === 'small' || variant === 'xsmall' && css(["flex-shrink:0;padding:0 36px 0 0;", ";"], maxMediaQueries.tablet(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral(["\n        padding: 18px;\n        padding-top: 0;\n      "]))));
});
export var SecondaryCTA = styled.a.withConfig({
  displayName: "partials__SecondaryCTA",
  componentId: "sc-1pwvfn9-6"
})(["font-weight:600;color:", ";"], function (_ref23) {
  var theme = _ref23.theme;
  return theme.colors.secondary;
});